import * as constants from './constants'

export const getProperties = propertyName => ({
  type: constants.GET_PROPERTIES.ACTION,
  payload: { propertyName }
})

export const getPropertySearchList = payload => ({
  type: constants.GET_PROPERTY_SEARCH_LIST.ACTION,
  payload
})

export const resetListSearchResults = () => ({
  type: constants.RESET_LIST_SEARCH_RESULTS.ACTION
})

